export type PermisoMap = Record<string, string> | null | undefined

// Visibilidad de menú: visible si e/sl/u; oculto si "n"/"h" o clave ausente.
// Sin permisos cargados => todo visible (default seguro para usuarios sin
// perfil asignado, que heredan los permisos por tipo).
export function tienePermiso(permisos: PermisoMap, nombrePermiso: string): boolean {
  if (!permisos || typeof permisos !== "object" || Object.keys(permisos).length === 0) return true
  const valor = permisos[nombrePermiso]
  if (valor === undefined || valor === null) return false
  return ["e", "sl", "u"].includes(String(valor))
}

// Acceso a ruta: bloquear sólo cuando el permiso está explícitamente denegado
// ("n"/"h"). Clave ausente o sin permisos => permitido, para no romper rutas
// cuya clave no forma parte del vocabulario gestionado.
export function permisoDenegado(permisos: PermisoMap, nombrePermiso: string): boolean {
  if (!permisos || typeof permisos !== "object" || Object.keys(permisos).length === 0) return false
  const valor = permisos[nombrePermiso]
  return valor === "n" || valor === "h"
}

// Ruta de aterrizaje (post-login y permiso-denegado): la PRIMERA ruta del menú
// que el usuario puede ver, en el mismo orden que el Sidebar. Antes todo
// redirigía fijo a /index, que era la única ruta sin gate — un empleado con
// home_all="n" aterrizaba en el Dashboard aunque su perfil lo denegara.
// El gate de cada ruta usa permisoDenegado + soloTipos (mismos criterios que
// los TipoGate de App.tsx), así el destino devuelto nunca rebota (sin loops).
const RUTAS_LANDING: Array<{ href: string; permiso: string; soloTipos?: string[] }> = [
  { href: "/index", permiso: "home_all" },
  { href: "/saldos", permiso: "saldos_all", soloTipos: ["A", "B", "C", "R"] },
  { href: "/ventas", permiso: "ventas_all", soloTipos: ["Admin", "A", "B", "C", "R"] },
  { href: "/recarga", permiso: "activacion_all", soloTipos: ["B", "C", "R"] },
  { href: "/portabilidad-activacion", permiso: "activacion_all", soloTipos: ["B", "C"] },
  { href: "/inventario-de-sims", permiso: "inventarios_all", soloTipos: ["Admin", "A", "B", "C"] },
  { href: "/compras", permiso: "compras_all", soloTipos: ["A", "B", "C", "R"] },
  { href: "/usuarios", permiso: "usuarios_all", soloTipos: ["Admin", "A", "B"] },
  { href: "/reportes", permiso: "reportes_all", soloTipos: ["Admin", "A", "M", "B", "C"] },
  { href: "/comisiones", permiso: "comisiones_all", soloTipos: ["Admin", "A", "B", "M"] },
  { href: "/publicidad-y-manuales", permiso: "publicidad_y_anuncios_all" },
  { href: "/perfil", permiso: "perfil_all" },
]

export function rutaInicio(
  user: { tipo_usuario?: string; permisos?: PermisoMap } | null | undefined
): string {
  if (!user) return "/index"
  for (const ruta of RUTAS_LANDING) {
    if (ruta.soloTipos && user.tipo_usuario && !ruta.soloTipos.includes(user.tipo_usuario)) continue
    if (permisoDenegado(user.permisos, ruta.permiso)) continue
    return ruta.href
  }
  // Perfil con TODO denegado (ej. perfiles "en blanco"): página informativa.
  return "/sin-acceso"
}
